import { Period } from '@spike/model';
import { fetchTipDetailReportForExport } from 'actions/tipsReport/TipsReportActions';
import ExportCSV from 'components/UI/ExportCSV/ExportCSV';
import { useMarketplace } from 'hooks';
import { TipsReportStatus } from 'reducers/tipsReport/TipsReportState';
import { FunctionComponent, useRef, useState } from 'react';
import { convertToStaffFilter, convertToTipDetails } from './TipDetailsConverter';

interface TipsDetailExportCSVProps {
    period: Period;
    staffIds: Array<number>;
}

const headers = ['Date', 'Invoice', 'Client', 'Staff', 'Payment Type', 'Tip', 'Refunded'];

const TipsDetailExportCSV: FunctionComponent<TipsDetailExportCSVProps> = props => {
    const marketplace = useMarketplace();
    const csvRef = useRef<any>(null);

    const [records, setRecords] = useState<Array<Array<string>>>([]);
    const [exporting, setExporting] = useState(false);

    const exportHandler = async () => {
        setExporting(true);
        try {
            const report = await fetchTipDetailReportForExport(
                props.period.from.format('YYYY/MM/DD'),
                props.period.to.format('YYYY/MM/DD'),
                convertToStaffFilter(props.staffIds)
            );
            const tips = convertToTipDetails(
                { invoices: report.invoices, status: TipsReportStatus.GettingSuccess, loading: false },
                props.staffIds
            );
            setRecords(
                tips.map(tip => [
                    tip.createdAt ?? '',
                    String(tip.invoiceId),
                    tip.customerName,
                    tip.staffName,
                    tip.paymentType ?? '',
                    tip.amount,
                    Number(tip.refundedAmount) > 0 ? `-${tip.refundedAmount}` : '0.00'
                ])
            );
            setTimeout(() => csvRef.current?.export());
        } finally {
            setExporting(false);
        }
    };

    return (
        <ExportCSV
            headers={headers}
            records={records}
            filename={`${marketplace.basics.businessName} Tips Detail.csv`}
            ref={csvRef}
            exporting={exporting}
            onClick={exportHandler}
        />
    );
};

export default TipsDetailExportCSV;
